import { useLoginInfo } from '@/components/LoginInfo/provider';
import { useInvoiceReportsRoute } from '@/features/InvoiceReport/Edit/components/Context/API';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { useCallback, useMemo, useState } from 'react';

const AI_OCR_REFLECTION_LOCALSTORAGE_KEY = 'aiOcrReflectionEnabled';

enum AiOcrReflectionState {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
}

export const useIsAiOcrReflectionEnabled = (officeId: string) => {
  return useMemo(() => {
    const localStorageValue = window.localStorage.getItem(
      `${AI_OCR_REFLECTION_LOCALSTORAGE_KEY}_${officeId}`
    );
    // If no value exists in localStorage, return null to indicate no preference
    if (localStorageValue === null) {
      return null;
    }
    return localStorageValue === AiOcrReflectionState.ENABLED;
  }, [officeId]);
};

export const useCheckEventForAiOcrReflection = (
  defaultValue: boolean = true
) => {
  const route = useInvoiceReportsRoute();
  const { currentOffice } = useLoginInfo();
  const isAiOcrReflectionEnabled = useIsAiOcrReflectionEnabled(
    currentOffice?.id ?? ''
  );
  const [checked, setChecked] = useState(
    route === 'normal' && isAiOcrReflectionEnabled !== null
      ? isAiOcrReflectionEnabled
      : defaultValue
  );
  const onChange = useCallback(
    (e: CheckboxChangeEvent) => {
      if (route === 'normal' && currentOffice?.id) {
        updateAiOcrReflectionLocalStorage(e.target.checked, currentOffice.id);
      }
      setChecked(e.target.checked);
    },
    [currentOffice?.id, route]
  );
  return {
    checked,
    onChange,
  };
};

export const updateAiOcrReflectionLocalStorage = (
  isAiOcrReflectionEnabled: boolean,
  officeId: string
) => {
  window.localStorage.setItem(
    `${AI_OCR_REFLECTION_LOCALSTORAGE_KEY}_${officeId}`,
    isAiOcrReflectionEnabled
      ? AiOcrReflectionState.ENABLED
      : AiOcrReflectionState.DISABLED
  );
};
